<ng-container *ngIf="logged === true">
  <div class="container-fluid">
    <div class="row col-12 mb-5">
      <div class="col-1">
        <a [routerLink]="['']"><img src="assets/logo.png" alt="logo" class="w-100"></a>
      </div>
      <div class="col-1 align-self-center"><a [routerLink]="['zakazka', 'rozpracovane']">Zakázky</a></div>
      <div class="col-1 align-self-center"><a [routerLink]="['sablony']">Šablony</a></div>
      <div class="col-1 align-self-center"><a [routerLink]="['subjekt']">Partneři</a></div>
      <div class="col-1 align-self-center"><a [routerLink]="['fakturace']">Fakturace</a></div>
    </div>
    <router-outlet></router-outlet>
  </div>
</ng-container>

<ng-container *ngIf="!logged && auth === true">
  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<!--<ng-container *ngIf="logged === false">
    <div class="container">
      <div class="mx-auto mt-5 col-md-6 col-sm-12">
        <div class="card">
          <form>
            <div class="card-header py-3">
              <h2>Přihlášení</h2>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <label for="login" class="form-label">Login</label>
                <input type="text" name="username" class="form-control" autocomplete="off" placeholder="Zadejte uživatelské jméno" [(ngModel)]="username">
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Heslo</label>
                <input type="password" name="password" class="form-control" autocomplete="off" placeholder="Zadejte heslo" [(ngModel)]="password">
              </div>
              <button type="submit" (click)="login()" class="btn btn-primary w-100 text-uppercase">Přihlásit se</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
-->